import request from '@/utils/request'

export function fetchCatelogList (query) {
  return request({
    url: '/auth/api/catelog/index',
    method: 'get',
    params: query
  })
}

export function fetchCatelog (id) {
  return request({
    url: '/auth/api/catelog/view',
    method: 'get',
    params: { id }
  })
}

export function createCatelog (data) {
  return request({
    url: '/auth/api/catelog/insert',
    method: 'post',
    data
  })
}

export function updateCatelog (data) {
  return request({
    url: '/auth/api/catelog/update',
    method: 'post',
    data
  })
}

export function deleteCatelog (id) {
  return request({
    url: '/auth/api/catelog/delete',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/api/catelog.js